<template>
  <div>
    <div class="upload-wrapper" v-if="tokenVerified">
      <upload-documents
        ref="uploadDocuments"
        :data="uploadData"
        @update:files="updateFiles"
      />
      <button
        @click="onClickUpdate"
        class="btn-update mt-2"
        :disabled="isLoading"
      >
        <span v-if="!isLoading">Update</span>
        <span v-else><b-spinner small></b-spinner> Processing ...</span>
      </button>
    </div>
    <div v-if="!tokenVerified" class="upload-wrapper" style="padding: 2.5rem">
      <div class="text-center">
        <h2>The reupload link is no longer valid as documents have already been submitted.</h2>
      </div>
    </div>
  </div>
</template>

<script>
import UploadDocuments from './partials/UploadDocuments.vue';
import HTTPRequest from '../../controllers/httpRequest';
import axios from 'axios';

const S3Api = process.env.VUE_APP_CLP_S3_API;
const S3ApiKey = process.env.VUE_APP_CLP_S3_API_KEY;

export default {
  name: 'ReuploadDocument',
  components: {
    UploadDocuments
  },
  data() {
    return {
      uploadData: {
        files: [],
        isCoop: true,
        isPartnerCorp: false,
        isProf: false,
        isSoleProp: false,
        optionalFilesCode: ['BIR_TAX'],
        memberTypeId: null,
        subMemberTypeId: null,
        memberId: null,
        memberTypeUpdated: true
      },
      tokenVerified: false,
      isLoading: false
    };
  },
  methods: {
    updateFiles(newFiles) {
      this.uploadData.files = newFiles;
    },
    async verifyToken(token) {
      if(token){
        const tokenResponse = await HTTPRequest.postRequest('/api/v2/clp_member_accounts/verify_token', 
        { token: token })
        
        if(tokenResponse.data){
          this.tokenVerified = true;
          this.uploadData.memberId = tokenResponse.data.memberId;
          this.uploadData.memberTypeId = tokenResponse.data.memberTypeId;
          this.uploadData.subMemberTypeId = tokenResponse.data.subMemberTypeId;
        }else{
          this.tokenVerified = false;
        }
      }
    },
    async fetchMemberUploads(data) {
      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/member_upload_type_mapping`,
        {
          member_type_id: data.memberTypeId, 
          sub_member_type_id: data.subMemberTypeId,
          targeted_member_type_id: null
        }
      );

      this.uploadData.files = response.data
    },
    async onClickUpdate() {
        try {
            this.isLoading = true;
            const files = this.uploadData.files;
            let memberUploads = [];
            let x = 0;
            let isValid = false;

            while (x < files.length) {
              const current = files[x];
              console.log('files[x]', current);
              
              if (current.is_required === 1 && (!current.file || current.file.length === 0)) {
                isValid = false
                this.uploadData.files[x].error = true;
                this.$refs.uploadDocuments.fetchFormData(this.uploadData);
              }

              // Upload if valid
              if (current.file && current.file.length > 0 && current.is_required === 1) {
                const { signedUrl, url } = await this.genSignedUrl(current.file);
                console.table({ signedUrl, url });

                const path = await this.s3Upload(current.file, signedUrl);
                console.log(path);

                memberUploads.push({
                    member_upload_type_id: current.id,
                    s3_url: url,
                });
                isValid = true
              }

              x++;
            }

            if(isValid){
              const memberId = this.uploadData.memberId;
              const memberTypeId = this.uploadData.memberTypeId;

              const payload = {
                member_id: memberId,
                member_type_id: memberTypeId,
                member_uploads: memberUploads
              };

              const response = await HTTPRequest.postRequest('/api/v2/clp_member_accounts/re_upload', payload);
              console.log(response);

              this.$message.success(response.message || 'Uploaded successfully');
              this.$router.push({ name: 'MemberLogin' });
              this.isLoading = false;
            }else{
              this.isLoading = false;
            }
        } catch (error) {
            console.error('Upload failed:', error);
            const errMsg = error.response?.data?.error || 'Uploading failed. Please try again.';
            this.$message.error(errMsg);
            this.isLoading = false;
        }
    },
    async genSignedUrl(file = []) {
      if (file && file.length > 0 && file[0] instanceof File) {
        try {
          const { name: fileName, type: fileType } = file[0];
          const genResult = await axios({
            method: 'POST',
            url:
              S3Api +
              '?account_name=cw' +
              '&profile=member-registration-requirements',
            headers: {
              'x-app-key': S3ApiKey,
            },
            data: JSON.stringify({
              fileName,
              fileType,
            }),
          });
          const { signedUrl, url } = genResult.data;
          return { signedUrl, url };
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },
    async s3Upload(file = [], url) {
      if (file && file.length > 0 && file[0] instanceof File) {
        const { type: fileType } = file[0];
        const readBufferFile = await this.readFileAsArrayBuffer(file[0]);
        const formData = new FormData();
        formData.append('file', readBufferFile);
        let filePath = null;
        try {
          const upload = await axios.put(url, readBufferFile, {
            headers: {
              'Content-Type': fileType,
            },
          });

          console.log('uploadResponse ', upload);

          if (upload.status === 200) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
  },
  async created() {
    await this.verifyToken(this.$route.query.token);
    if (this.tokenVerified) {
      await this.fetchMemberUploads(this.uploadData);
    }
  }
};
</script>

<style scoped>
.upload-wrapper {
  padding: 15px;
  background-color: white;
  box-shadow: 0 0 10px #ddd;
  border-radius: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  color: #003A90 !important;
}

.btn-update {
  background: linear-gradient(135deg, #F15A22, #F15A22);
  box-shadow: 0 4px 10px rgba(249, 90, 44, 0.5);
  border: none;
  border-radius: 25px;
  color: white;
  font-weight: 700;
  padding: 5px 20px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.btn-update:hover {
  background: linear-gradient(135deg, #F15A22, #F15A22);
}
</style>
